$(document).ready(function () {
  /** mega menu **/

  function getBackgroundImages() {
    const images = [];
    
    $('#get-bg-img-col .bg-input').each(function() {
      const bgImg = $(this).attr('bg-img');
      
      if(bgImg) {
        images.push(bgImg);
      }
    });
  
  return images;
  }

  function preloadMegaMenuImages(images) {
    images.forEach((image) => {
      const img = new Image();
      img.src = image;
    });
  }

  const preloadImages = getBackgroundImages();

  preloadMegaMenuImages(preloadImages);
  
  $("ul.list-menu li.ctm-mega-chage-bg.ctm-mega-listmn").hover(
    function () {
      var get_this_item = $(this).find('span').text().replace(/\s+/g, "");

      const parent = this.parentElement;
      const distance = this.getBoundingClientRect().left - parent.getBoundingClientRect().left - parent.clientLeft;

      var margin_left = distance + 'px';

      $("li.ctm-mega-chage-bg.ctm-mega-listmn, li.ctm-no-link").removeClass("sec-active");
      $(this).addClass("sec-active");

      $('.mega-custom-outer .ctm-mega-menu__list').hide().removeClass('active');
      $('.mega-custom-outer .mega-custom-featured').hide().removeClass('active');

      $('.mega-custom-outer .ctm-mega-menu__list.clas-show-' + get_this_item).not('.new-column').css('margin-left', margin_left);

      $('.mega-custom-outer .ctm-mega-menu__list.clas-show-' + get_this_item)
        .show()
        .addClass('active');

      $('.mega-custom-outer .mega-custom-featured[data-link="' + get_this_item + '"]')
        .show()
        .addClass('active');
    },
    function () {
      $("sticky-header#ctm-nav-sticky").css("background-color", "#000");
    }
  );
  
  $(".ctm-mega-chage-bg, .ctm-no-link").not(".ctm-about-menu, .ctm-about-menu *").hover(
    function () {
      $('.mega-custom-outer').show();
      $('body').addClass('mega-menu-active');
      
      $(".ctm-mega-chage-bg").removeClass("active");
      $(this).addClass("active");

      if($(this).closest('.ctm-mega-menu__list').length){
        $('.mega-custom-outer .ctm-mega-menu__list').removeClass('active');
        //$(this).closest('.ctm-mega-menu__list').addClass('active');
        $(this).closest('.ctm-mega-menu__content').find('.ctm-mega-menu__list').addClass('active');
      };
     
      var get_data_active = $(this).closest('.ctm-mega-menu__list').attr('data-active');

      $('li.ctm-mega-chage-bg.ctm-mega-listmn').removeClass('sec-active');
      $('li.ctm-mega-chage-bg.ctm-mega-listmn.show-' + get_data_active).addClass('sec-active');

      var $this = $(this);
      var $source = $this.is('a') ? $this : $this.find('a').first();

      if (!$source.length) $source = $this;

      var get_this_title = $source.text().replace(/\s+/g, "");
      var get_this_parent = $source.attr('data-parent');
      
      $("div#get-bg-img-col input.bg-input").each(function () {
        var get_nav_item_color = $(this).attr("nav_item_color");
        var get_nav_item = $(this).attr("data-nav-item").replace(/\s+/g, "");
        var get_nav_parent = $(this).attr("data-nav-parent").replace(/\s+/g, "");
        var get_bg_img = $(this).attr("bg-img");
        var get_bg_color = $(this).attr("bg-color");

        if(get_this_title === get_nav_item || get_this_parent == get_nav_parent) {
          if (get_nav_item_color) {
            $("sticky-header#ctm-nav-sticky").addClass("black-nav-item");
          } 
          else {
            $("sticky-header#ctm-nav-sticky").removeClass("black-nav-item");
          }

          if (get_bg_img) {
            $("sticky-header#ctm-nav-sticky").css(
              "background-image",
              "url(" + get_bg_img + ")"
            );
          } else {
            $("sticky-header#ctm-nav-sticky").css("background-image", "none");
          }
          if (get_bg_color) {
            $("sticky-header#ctm-nav-sticky").css(
              "background-color",
              get_bg_color
            );
          }
        }
      });
    },
    function () {
      $(".ctm-about-menu__link, .ctm-no-link").not(".ctm-about-menu .ctm-about-menu__link, .ctm-about-menu .ctm-no-link").removeClass("active");
        
      //$(".ctm-mega-chage-bg, .ctm-no-link").removeClass("active");
      //$("sticky-header#ctm-nav-sticky").css("background-image", "none");
      //$("sticky-header#ctm-nav-sticky").css("background-color", "#000");
      //$("sticky-header#ctm-nav-sticky").removeClass("black-nav-item");
      // $('.mega-custom-outer').hide();
      // $('body').removeClass('mega-menu-active');
    }
  );

  
  $(".mega-custom-wrp, .header__inline-menu").hover(
    function () {},
    function () {
      $('.mega-custom-outer').hide();
      $('body').removeClass('mega-menu-active');
      $("sticky-header#ctm-nav-sticky").css("background-color", "#000");
    }
  );

  /***************************----mega-menu-end-----***********************************/

  $(".grid__item.product__media-wrapper .product__media-list .deferred-media__poster").click();
    $(".product__media-wrapper .product__media-item video").each(function () {
      if (this.paused) {
        this.play();
      }
    });
    $("video").each(function () {
      if (
        $(this).attr("autoplay") === "autoplay" ||
        $(this).attr("autoplay") === "true"
      ) {
        if (this.paused) {
          this.play();
        }
      }
    });

  var get_var_url = window.location.href;
  var variantId = get_var_url.match(/variant=(\d+)/);
  if (variantId && variantId.length > 1) {
   // console.log(variantId[1]);
    $(".show_variant_aval_qunt.id--" + variantId[1]).show();
  }

  $(".accordion_tab_title").click(function () {
    $(this)
      .toggleClass("active")
      .next(".accordion_tab_content")
      .slideToggle()
      .parent()
      .siblings()
      .find(".accordion_tab_content")
      .slideUp()
      .prev()
      .removeClass("active");
  });

  $(".as_seen_on_slider").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    speed: 300,
    infinite: true,
    autoplaySpeed: 1500,
    autoplay: false,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });

  /***blog post_slideres--start***/
  $(".first_blog_images_slider_first").slick({
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    arrows: false,
  });

  $(".ctm_first_blog_main_wrp_slider").slick({
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    arrows: false,
  });

  $(".mobile_ctm_slider").slick({
    dots: false,
    infinite: true,
    speed: 500,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    slidesToShow: 1.1,
    centerPadding: "150px",
  });

  /***blog post_slideres--end***/

  $(".logo_text_block_counter_slider").slick({
    dots: true,
    infinite: true,
    speed: 500,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    arrows: false,
    slidesToShow: 1,
  });

  if (window.innerWidth > 750) {
    $(".image_overlay_blocks_slider").slick({
      dots: true,
      infinite: false,
      speed: 500,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 2000,
      arrows: false,
      slidesToShow: 1,
      adaptiveHeight: true,
    });
  }

  if (window.innerWidth < 750) {
    $(".images_grid_inner").slick({
      dots: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      arrows: false,
    });
  }
});

/**
  Raide Research Customization
  Author: Patrick Gephart <pmgephart@gmail.com>
**/

document.addEventListener('DOMContentLoaded', function () {
  const radios = document.querySelectorAll('.raide-newsletter input[name="newsletter_list"]');
  const tagsInput = document.getElementById('raide-newsletter-tags');

  if(!radios.length || !tagsInput) return;

  radios.forEach(radio => {
    radio.addEventListener('change', function () {
        tagsInput.value = this.value;
    });
  });
});

/** update newsletter tags in newsletter forms **/

document.addEventListener('DOMContentLoaded', function () {
  const radios = document.querySelectorAll('.raide-footer-newsletter input[name="newsletter_list"]');
  const tagsInput = document.getElementById('raide-footer-newsletter-tags');

  if(!radios.length || !tagsInput) return;

  radios.forEach(radio => {
    radio.addEventListener('change', function () {
        tagsInput.value = this.value;
    });
  });
});

/** product grid item variants **/

const prodGridvariantsBtn = document.querySelectorAll('.product-grid-item .product-varisnt-btn');

function productGridUpdateVariantChange() {
    const parent = this.parentNode;
    const parentItem = this.closest('.product-grid-item');
    const variantImg = this.dataset.image;
    const variantUrl = this.dataset.url;
    const variantVideo = this.dataset.video;
    const variantBtns = parent.querySelectorAll('.product-varisnt-btn');
    const links = parentItem.querySelectorAll('a');

    const videoElement = parentItem.getElementsByClassName('video-wrapper');
    const imageElement = parentItem.getElementsByClassName('image-wrapper');
    
    if(variantVideo == 1) {
        if(videoElement.length > 0) {
            videoElement[0].style.display = "block";
        }

        if(imageElement.length > 0) {
            imageElement[0].style.display = "none";
        }
    }
    else {
        if(videoElement.length > 0) {
            videoElement[0].style.display = "none";
        }

        if(imageElement.length > 0) {
            imageElement[0].style.display = "block";
            imageElement[0].querySelector('img').src = variantImg;
        }
    }

    variantBtns.forEach(variant => variant.classList.remove('active'));
    links.forEach(link => link.href = variantUrl);

    this.classList.add('active');
}

for(var i = 0; i < prodGridvariantsBtn.length; i++) {
    prodGridvariantsBtn[i].addEventListener("click", productGridUpdateVariantChange, false);
}

/** Judge.me product review updates **/

(() => {
    const insertRatingCircle = () => {
        const summary = document.querySelector('.jdgm-rev-widg__summary');
        if (!summary) return false;

        const ratingElement = summary.querySelector('.jdgm-rev-widg__summary-average');
        if (!ratingElement) return false;

        const rating = parseFloat(ratingElement.textContent);
        if (!Number.isFinite(rating)) return false;

        let circle = summary.querySelector('.raide-review-rating');

        if (!circle) {
            circle = document.createElement('div');
            circle.className = 'raide-review-rating';
            summary.prepend(circle);
        }

        circle.textContent = rating.toFixed(2);

        return true;
    };

    if (insertRatingCircle()) return;

    const observer = new MutationObserver(() => {
        if (insertRatingCircle()) {
            observer.disconnect();
        }
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

    document.querySelectorAll('.jdgm-rev__rating[data-score]').forEach((rating) => {
      const score = parseFloat(rating.dataset.score);

      if (!Number.isNaN(score)) {
          rating.dataset.displayScore = score.toFixed(1);
      }
  });
})();


/** Header background and marquee behavior when scrolling */

document.addEventListener('DOMContentLoaded', () => {
    const header = document.querySelector('.section-header');
    const headerInner = document.querySelector('.section-header .header');
    const marquee = document.querySelector('.section-raide-header-marquee');
    const main = document.querySelector('main.content-for-layout');
    const mobileQuery = window.matchMedia('(max-width: 989px)');

    if (!header) return;

    let marqueeHeight = 0;
    let resizeTimeout;

    const updateHeaderPosition = () => {
        if (!headerInner) return;

        const rect = headerInner.getBoundingClientRect();
        const height = Math.max(0, rect.bottom);

        document.documentElement.style.setProperty('--header-height', `${height}px`);
    };

    const updateHeights = () => {
        if (marquee) {
            const wasHidden = marquee.classList.contains('marquee-hidden');

            if (wasHidden) {
                marquee.classList.remove('marquee-hidden');
            }

            marqueeHeight = marquee.getBoundingClientRect().height;

            if (wasHidden) {
                marquee.classList.add('marquee-hidden');
            }
        }

        const headerHeight = header.getBoundingClientRect().height;

        if (!document.documentElement.style.getPropertyValue('--initial-header-height')) {
            document.documentElement.style.setProperty('--initial-header-height', `${headerHeight}px`);
            document.documentElement.style.setProperty('--initial-marquee-height', `${marqueeHeight}px`);
        }

        document.documentElement.style.setProperty('--marquee-height', `${marqueeHeight}px`);
        header.style.setProperty('--marquee-height', `${marqueeHeight}px`);

        if (main) {
          main.style.setProperty('--marquee-height', `${marqueeHeight}px`);
          main.style.setProperty('--header-height', `${headerHeight}px`);
        }

        updateHeaderPosition();
    };

    const updateHeader = () => {
      const isScrolled = mobileQuery.matches && window.scrollY > 10;

      header.classList.toggle('header-scrolled', isScrolled);
      header.classList.toggle('marquee-collapsed', isScrolled);

      if (marquee) {
          marquee.classList.toggle('marquee-hidden', isScrolled);
      }

      document.documentElement.style.setProperty('--visible-marquee-height', `${marquee && !isScrolled ? marqueeHeight : 0}px`);

      updateHeaderPosition();
  };

    const updateLayout = () => {
        updateHeights();
        updateHeader();
    };

    window.addEventListener('scroll', updateHeader, { passive: true });

    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);

        resizeTimeout = setTimeout(() => {
            updateLayout();
        }, 150);
    }, { passive: true });

    if (headerInner) {
        new ResizeObserver(updateHeaderPosition).observe(headerInner);
    }

    updateLayout();

    window.addEventListener('load', updateLayout, { once: true });
});

/** lightbox **/

document.querySelectorAll('[data-raide-lightbox]').forEach((lightbox) => {
  const openButtons = document.querySelectorAll(`[data-raide-lightbox-open="${lightbox.id}"]`);
  const closeButtons = lightbox.querySelectorAll('[data-raide-lightbox-close]');
  const content = lightbox.querySelector('.raide-lightbox__content');
  let previousFocus = null;
  let previousOverflow = '';

  const openLightbox = () => {
    previousFocus = document.activeElement;
    previousOverflow = document.body.style.overflow;

    lightbox.classList.add('is-open');
    lightbox.removeAttribute('inert');
    lightbox.setAttribute('aria-hidden', 'false');

    document.body.style.overflow = 'hidden';

    content.scrollTop = 0;
    lightbox.querySelector('.raide-lightbox__close')?.focus();
  };

  const closeLightbox = () => {
    lightbox.classList.remove('is-open');
    lightbox.setAttribute('aria-hidden', 'true');
    lightbox.setAttribute('inert', '');

    document.body.style.overflow = previousOverflow;

    if (previousFocus?.isConnected) previousFocus.focus();
  };

  openButtons.forEach((button) => {
    button.addEventListener('click', (event) => {
      if (button.tagName === 'A') {
        event.preventDefault();
      }

      openLightbox();
    });
  });

  closeButtons.forEach((button) => {
    button.addEventListener('click', closeLightbox);
  });

  lightbox.addEventListener('click', (event) => {
    if (!content.contains(event.target)) {
      closeLightbox();
    }
  });

  lightbox.addEventListener('keydown', (event) => {
    if (!lightbox.classList.contains('is-open')) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      closeLightbox();
    }

    if (event.key === 'Tab') {
      const focusable = Array.from(lightbox.querySelectorAll('button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])')).filter((element) => element.getClientRects().length && !element.disabled);

      if (!focusable.length) {
        event.preventDefault();
        return;
      }

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      }
      else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  });
});

document.querySelectorAll('[data-raide-size-guide]').forEach((sizeGuide) => {
  const tabs = sizeGuide.querySelectorAll('[data-size-guide-target]');
  const images = sizeGuide.querySelectorAll('[data-size-guide-image]');

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      const target = tab.dataset.sizeGuideTarget;

      tabs.forEach((item) => {
        const isActive = item === tab;

        item.classList.toggle('active', isActive);
        item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      images.forEach((image) => {
        image.classList.toggle('active', image.dataset.sizeGuideImage === target);
      });
    });
  });
});

document.querySelectorAll('[data-raide-lightbox]').forEach((lightbox) => {
  if (lightbox.parentElement !== document.body) {
    document.body.appendChild(lightbox);
  }
});